import React, { Component, Fragment } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import SupportListView from './ListView';
import SupportTicket from './SupportTicket';
import StatusView from './StatusView';

class AuthRoute extends Component {
    isAllowed(claims, name) {
        let permissions = claims;
        let str = `${name && name.toLowerCase()}`;
        let isEnabled = permissions && permissions.includes(str);
        if (isEnabled) {
            return true
        }
        return false;
    }
    render() {
        const { component: Component, name, claims, ...rest } = this.props;
        let isAccessable = this.isAllowed(claims, name);
        return (
            <Route exact={true} {...rest} render={(props) => (
                (isAccessable === true) ?
                    <Fragment>
                        <Component {...props} claims={claims} />
                    </Fragment>
                    : null
            )} />
        )
    }
}

class Support extends Component {
    render() {
        const { claims } = this.props;
        return (
            <Fragment>
                <Switch>
                    <AuthRoute exact path='/support' component={SupportListView} name="support_view" claims={claims} />
                    <AuthRoute exact path='/support/ticket' component={SupportTicket} name="support_viewstatus" claims={claims} />
                    <AuthRoute exact path='/support/status' component={StatusView} name="support_viewstatus" claims={claims} />
                </Switch>
            </Fragment>
        )
    }
}

export default Support;